import Http from '@services/httpClient';

const prefix = '/api/v1/user';

export default {
  updatePreference(data: object) {
    return new Promise((resolve, reject) => {
      Http.put({
        url: `${prefix}/preference`,
        data,
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },

  getProfile(): Promise<object> {
    return new Promise((resolve, reject) => {
      Http.get({
        url: `${prefix}/profile`,
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },

  checkPhone(phone: string): Promise<any> {
    return new Promise((resolve, reject) => {
      Http.post({
        url: '/api/v1/check-phone-number',
        data: { phone },
      })
        .then((res) => resolve(res.data))
        .catch((e) => reject(e));
    });
  },
};
